/**
 * Created by tofael on 3/22/17.
 */

import { applyMiddleware, createStore } from 'redux'

import logger from 'redux-logger'
import promise from 'redux-promise-middleware'

import reducer from './reducers'

const middleware = applyMiddleware(promise(), logger())

export default createStore(reducer, middleware)


// WEBPACK FOOTER //
// ./src/store.js